import { Box, Container, SxProps, useTheme } from "@mui/material"
import { PropsWithChildren, useState } from "react";
import sisbackground from '../../assets/SIS_Background.jpg';

export const LoginBackground = ({
    children
}: PropsWithChildren) => {

    const theme = useTheme();
    const [backgroundImageLoaded, setBackgroundImageLoaded] = useState(false);

    const commonProps: SxProps = { position: 'absolute', width: '100vw', height: '100vh', left: 0, top: 0 };

    return (
        <Container
            sx={{
                position: 'relative',
                background: 'black',
                minWidth: '100vw',
                height: '100vh',
                textAlign: 'center',
                color: theme.palette.common.white,
                padding: 8,
                overflow: 'hidden'
            }}
        >
            <img src={sisbackground} alt="background" style={{ opacity: 0, width: 0, height: 0 }} onLoad={() => setBackgroundImageLoaded(true)} />
            <Box
                sx={{
                    backgroundImage: `url("${sisbackground}")`, backgroundSize: 'cover', 
                    scale: backgroundImageLoaded ? 1 : 1.6, 
                    animation: backgroundImageLoaded ? '4s 0s 1 scale-out' : undefined,
                    ...commonProps
                }}>
            </Box>
            <Box
                sx={{
                    background: 'black', 
                    opacity: backgroundImageLoaded ? 0 : 1, 
                    animation: backgroundImageLoaded ? '4s 0s 1 fade-in' : undefined,
                    ...commonProps
                }}>
            </Box>
            {children}
        </Container>
    )
}
